import { LOCAL } from "@/store/mutations";
import { randomValue } from "@/lib/random";

const { SET_HINT, CREATE_HINTS } = LOCAL;

export default {
	namespaced: true,
	state: {
		list: {},
		activeId: 0,
	},
	getters: {
		active: (state) => state.list[state.activeId],
		unused: (state) => Object.values(state.list).filter((hint) => !hint.used),
	},
	actions: {
		configureApp: {
			root: true,
			handler({ commit, dispatch }, configData) {
				commit(CREATE_HINTS, { list: configData.ui.hints });
				dispatch("set", configData.ui.hints[1]);
			},
		},
		randomize({ dispatch, commit, getters, rootState }) {
			if (!getters.unused.length) {
				commit(CREATE_HINTS, { list: rootState.global.api.data.ui.hints });
			}

			const hint = randomValue(getters.unused);
			dispatch(SET_HINT, hint);
		},
		set({ commit }, hint) {
			commit(SET_HINT, hint);
		},
	},
	mutations: {
		[CREATE_HINTS](state, hints) {
			state.list = { ...hints.list };
		},
		[SET_HINT](state, hint) {
			state.activeId = hint.id;
			state.list = { ...state.list, [hint.id]: { ...hint, used: true } };
		},
	},
};
